import React from "react";

const Textarea = React.forwardRef(
  ({ label, rows = 4, className = "", wrapperClassName = "", error = null, ...props }, ref) => {
    return (
      <div className={`w-full ${wrapperClassName}`}>
        {label && (
          <label htmlFor={props.id} className="block text-sm font-medium text-muted-foreground mb-1">
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          rows={rows}
          className={`ui-input resize-none ${error ? "ui-input-error" : ""} ${className}`}
          aria-invalid={error ? "true" : undefined}
          aria-describedby={error ? `${props.id || "textarea"}-error` : undefined}
          {...props}
        />
        {error && (
          <p id={`${props.id || "textarea"}-error`} className="mt-1 text-xs text-red-600 dark:text-red-400">
            {error}
          </p>
        )}
      </div>
    );
  }
);

Textarea.displayName = "Textarea";
export default Textarea;
